(function () {
  'use strict';

  const EARTH_MILES = 3958.7613;
  const DEFAULT_CENTER = [39.5, -98.35];
  const DEFAULT_ZOOM = 4;
  const NOMINATIM_URL = 'https://nominatim.openstreetmap.org/search';

  const STATE_ABBR_TO_NAME = {
    al: 'alabama', ak: 'alaska', az: 'arizona', ar: 'arkansas', ca: 'california',
    co: 'colorado', ct: 'connecticut', de: 'delaware', fl: 'florida', ga: 'georgia',
    hi: 'hawaii', id: 'idaho', il: 'illinois', in: 'indiana', ia: 'iowa',
    ks: 'kansas', ky: 'kentucky', la: 'louisiana', me: 'maine', md: 'maryland',
    ma: 'massachusetts', mi: 'michigan', mn: 'minnesota', ms: 'mississippi', mo: 'missouri',
    mt: 'montana', ne: 'nebraska', nv: 'nevada', nh: 'new hampshire', nj: 'new jersey',
    nm: 'new mexico', ny: 'new york', nc: 'north carolina', nd: 'north dakota', oh: 'ohio',
    ok: 'oklahoma', or: 'oregon', pa: 'pennsylvania', ri: 'rhode island', sc: 'south carolina',
    sd: 'south dakota', tn: 'tennessee', tx: 'texas', ut: 'utah', vt: 'vermont',
    va: 'virginia', wa: 'washington', wv: 'west virginia', wi: 'wisconsin', wy: 'wyoming',
    dc: 'district of columbia',
    on: 'ontario', bc: 'british columbia', ab: 'alberta', mb: 'manitoba',
    qc: 'quebec', nb: 'new brunswick', ns: 'nova scotia', sk: 'saskatchewan',
    nl: 'newfoundland and labrador', pe: 'prince edward island'
  };

  function boot() {
    const root = document.querySelector('.honeybee-store-locator');
    if (!root || root.getAttribute('data-honeybee-ready') === 'true') return;
    if (typeof window.L === 'undefined') {
      window.setTimeout(boot, 50);
      return;
    }
    root.setAttribute('data-honeybee-ready', 'true');
    init(root);
  }

  function init(root) {
    const els = {
      form: root.querySelector('#honeybee-search-form'),
      input: root.querySelector('#honeybee-search-input'),
      geoBtn: root.querySelector('#honeybee-geo-btn'),
      status: root.querySelector('#honeybee-status-line'),
      list: root.querySelector('#honeybee-store-list'),
      empty: root.querySelector('#honeybee-empty-state'),
      count: root.querySelector('#honeybee-result-count'),
      mapEl: root.querySelector('#honeybee-map'),
      dataEl: root.querySelector('#honeybee-store-data') || document.getElementById('honeybee-store-data')
    };

    let stores = [];
    let map;
    let markerLayer;
    let markersById = new Map();
    let origin = null;
    let selectedId = null;
    let geocodeTimer = 0;
    let geocodeAvailable = true;
    let geocodeBlockedNoted = false;

    function toRad(d) {
      return (d * Math.PI) / 180;
    }

    function haversineMiles(aLat, aLng, bLat, bLng) {
      const dLat = toRad(bLat - aLat);
      const dLng = toRad(bLng - aLng);
      const h =
        Math.sin(dLat / 2) ** 2 +
        Math.cos(toRad(aLat)) * Math.cos(toRad(bLat)) * Math.sin(dLng / 2) ** 2;
      return 2 * EARTH_MILES * Math.asin(Math.min(1, Math.sqrt(h)));
    }

    function cleanWebsite(url) {
      if (!url) return '';
      let u = String(url).trim();
      if (!u) return '';
      u = u.replace(/^(https?:\/\/)+/i, (match) =>
        match.toLowerCase().includes('https') ? 'https://' : 'http://'
      );
      u = u.replace(/^(https?:)\/(?!\/)/i, '$1//');
      const compact = u.replace(/\/+$/, '').toLowerCase();
      if (compact === 'http:' || compact === 'https:' || compact === 'http://' || compact === 'https://') {
        return '';
      }
      return u;
    }

    function telHref(phone) {
      const p = String(phone || '').trim();
      if (!p) return '';
      return 'tel:' + p.replace(/[^\d+]/g, '');
    }

    function escapeHtml(value) {
      return String(value == null ? '' : value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
    }

    function isPickupOnly(store) {
      if (store && (store.pickupOnly === true || store.pickupOnly === 'true')) return true;
      const blob = ((store.notes || '') + ' ' + (store.name || '')).toLowerCase();
      return blob.includes('pickup') || blob.includes('warehouse');
    }

    function selectedRadius() {
      const checked = root.querySelector('input[name="honeybee-radius"]:checked');
      const value = checked ? checked.value : 'all';
      if (value === 'all') return Infinity;
      return Number(value);
    }

    function setStatus(text) {
      if (els.status) els.status.textContent = text || '';
    }

    function pinIcon(active) {
      const color = active ? '#157e79' : '#1da59e';
      const svg =
        '<svg xmlns="http://www.w3.org/2000/svg" width="28" height="40" viewBox="0 0 28 40">' +
        '<path fill="' + color + '" stroke="#2b271f" stroke-width="1.4" d="M14 1.5c6.6 0 12 5.3 12 11.8 0 8.7-12 24.2-12 24.2S2 22 2 13.3C2 6.8 7.4 1.5 14 1.5z"/>' +
        '<circle cx="14" cy="13" r="4.2" fill="#fffdf7"/>' +
        '</svg>';
      return L.divIcon({
        className: 'pin-icon',
        html: svg,
        iconSize: [28, 40],
        iconAnchor: [14, 38],
        popupAnchor: [0, -34]
      });
    }

    function directionsUrl(store) {
      return 'https://www.google.com/maps/dir/?api=1&destination=' + encodeURIComponent(store.lat + ',' + store.lng);
    }

    function zipToStateName(zip) {
      const n = parseInt(String(zip).slice(0, 3), 10);
      if (!Number.isFinite(n)) return '';
      const ranges = [
        [10, 27, 'massachusetts'], [28, 29, 'rhode island'], [30, 38, 'new hampshire'],
        [39, 49, 'maine'], [50, 59, 'vermont'], [60, 69, 'connecticut'],
        [70, 89, 'new jersey'], [100, 149, 'new york'], [150, 196, 'pennsylvania'],
        [197, 199, 'delaware'], [200, 205, 'district of columbia'], [206, 219, 'maryland'],
        [220, 246, 'virginia'], [247, 268, 'west virginia'], [270, 289, 'north carolina'],
        [290, 299, 'south carolina'], [300, 319, 'georgia'], [320, 349, 'florida'],
        [350, 369, 'alabama'], [370, 385, 'tennessee'], [386, 397, 'mississippi'],
        [400, 427, 'kentucky'], [430, 459, 'ohio'], [460, 479, 'indiana'],
        [480, 499, 'michigan'], [500, 528, 'iowa'], [530, 549, 'wisconsin'],
        [550, 567, 'minnesota'], [570, 577, 'south dakota'], [580, 588, 'north dakota'],
        [590, 599, 'montana'], [600, 629, 'illinois'], [630, 658, 'missouri'],
        [660, 679, 'kansas'], [680, 693, 'nebraska'], [700, 714, 'louisiana'],
        [716, 729, 'arkansas'], [730, 749, 'oklahoma'], [750, 799, 'texas'],
        [800, 816, 'colorado'], [820, 831, 'wyoming'], [832, 838, 'idaho'],
        [840, 847, 'utah'], [850, 865, 'arizona'], [870, 884, 'new mexico'],
        [889, 898, 'nevada'], [900, 961, 'california'], [967, 968, 'hawaii'],
        [970, 979, 'oregon'], [980, 994, 'washington'], [995, 999, 'alaska']
      ];
      for (let i = 0; i < ranges.length; i++) {
        if (n >= ranges[i][0] && n <= ranges[i][1]) return ranges[i][2];
      }
      return '';
    }

    function storeSearchText(store) {
      let text = [store.name, store.address, store.phone, store.notes, store.hours]
        .join(' ')
        .toLowerCase();
      text = text.replace(/,\s*([a-z]{2})\b/g, function (match, abbr) {
        const name = STATE_ABBR_TO_NAME[abbr];
        return name ? match + ' ' + name : match;
      });
      text = text.replace(/\b([a-z]{2})[.\s]+(\d{5})\b/g, function (match, abbr) {
        const name = STATE_ABBR_TO_NAME[abbr];
        return name ? match + ' ' + name : match;
      });
      text = text.replace(/,\s*(\d{5})(?:-\d{4})?\b/g, function (match, zip) {
        const name = zipToStateName(zip);
        return name ? match + ' ' + name : match;
      });
      return text;
    }

    function hasCoords(store) {
      return Number.isFinite(Number(store.lat)) && Number.isFinite(Number(store.lng));
    }

    function filterStores() {
      const q = els.input ? els.input.value.trim().toLowerCase() : '';
      const radius = selectedRadius();
      const results = [];
      const placeBrowse = !!(origin && radius === Infinity);

      stores.forEach((store) => {
        const textHit = !q || storeSearchText(store).includes(q);
        let distance = null;
        if (origin && hasCoords(store)) {
          distance = haversineMiles(origin.lat, origin.lng, Number(store.lat), Number(store.lng));
        }
        const inRadius = !origin || radius === Infinity || (distance != null && distance <= radius);
        let include = false;
        if (placeBrowse) {
          if (q) {
            const anyText = stores.some((s) => storeSearchText(s).includes(q));
            include = anyText ? textHit : true;
          } else {
            include = true;
          }
        } else if (origin && radius !== Infinity) {
          include = inRadius || (!!q && textHit);
        } else {
          include = textHit;
        }
        if (include) {
          results.push(Object.assign({}, store, { _distance: distance }));
        }
      });

      results.sort((a, b) => {
        if (a._distance != null && b._distance != null && a._distance !== b._distance) {
          return a._distance - b._distance;
        }
        return String(a.name).localeCompare(String(b.name));
      });
      return results;
    }


    function formatAddressLines(address) {
      const raw = String(address || '').trim();
      if (!raw) return [];
      let rest = raw.replace(
        /,?\s*(USA|United States|Canada|Australia|Germany|Italy|The Netherlands|Netherlands|South Korea)\s*$/i,
        ''
      ).trim();
      rest = rest.replace(/,+\s*$/, '');

      let m = rest.match(/^(.*),\s*([^,]+),\s*([A-Za-z]{2})\s+(\d{5}(?:-\d{4})?)\s*$/);
      if (m) {
        return [m[1].trim(), m[2].trim() + ', ' + m[3].toUpperCase() + ' ' + m[4]];
      }

      m = rest.match(/^(.*),\s*([^,]+),\s*([A-Za-z]{2})\s+([A-Za-z]\d[A-Za-z]\s?\d[A-Za-z]\d)\s*$/);
      if (m) {
        let postal = m[4].toUpperCase().replace(/\s+/g, '');
        postal = postal.slice(0, 3) + ' ' + postal.slice(3);
        return [m[1].trim(), m[2].trim() + ', ' + m[3].toUpperCase() + ' ' + postal];
      }

      m = rest.match(/^(.*),\s*([^,]+?\s+\d{4})\s*$/);
      if (m) {
        return [m[1].trim(), m[2].trim()];
      }

      const parts = rest.split(',').map(function (p) { return p.trim(); }).filter(Boolean);
      if (parts.length >= 3) {
        return [parts.slice(0, -2).join(', '), parts.slice(-2).join(', ')];
      }
      if (parts.length === 2) {
        return [parts[0], parts[1]];
      }
      return [rest];
    }

    function formatHoursLines(hours) {
      const raw = String(hours || '').trim();
      if (!raw) return [];
      const chunks = raw.split(/\s*;\s*|\s*\|\s*/).map(function (s) { return s.trim(); }).filter(Boolean);
      const lines = [];
      chunks.forEach(function (chunk) {
        let buf = '';
        for (let i = 0; i < chunk.length; i++) {
          buf += chunk[i];
          if (
            chunk[i] === '.' &&
            chunk[i + 1] === ' ' &&
            /[A-Z]/.test(chunk[i + 2] || '')
          ) {
            lines.push(buf.trim());
            buf = '';
            i += 1;
          }
        }
        if (buf.trim()) lines.push(buf.trim());
      });
      return lines;
    }

    function linesToHtml(className, lines) {
      if (!lines.length) return '';
      return (
        '<p class="' + className + '">' +
        lines.map(function (line) {
          return '<span>' + escapeHtml(line) + '</span>';
        }).join('') +
        '</p>'
      );
    }

    function formatMiles(n) {
      if (n == null || !Number.isFinite(n)) return '';
      if (n < 10) return n.toFixed(1) + ' miles';
      return Math.round(n) + ' miles';
    }

    function detailsHtml(store, compact) {
      const parts = [];
      parts.push(linesToHtml('store-address', formatAddressLines(store.address)));
      if (store._distance != null) {
        parts.push('<p class="store-meta">' + escapeHtml(formatMiles(store._distance)) + ' away</p>');
      }
      if (store.phone) {
        parts.push(
          '<p class="store-meta"><a href="' +
            escapeHtml(telHref(store.phone)) +
            '">' +
            escapeHtml(store.phone) +
            '</a></p>'
        );
      }
      if (!compact && store.hours) {
        parts.push(linesToHtml('hours', formatHoursLines(store.hours)));
      }
      const bits = [];
      const site = cleanWebsite(store.website);
      if (site) {
        bits.push('<a href="' + escapeHtml(site) + '" target="_blank" rel="noopener noreferrer">Website</a>');
      }
      if (hasCoords(store)) {
        bits.push(
          '<a href="' +
            escapeHtml(directionsUrl(store)) +
            '" target="_blank" rel="noopener noreferrer">Get directions</a>'
        );
      }
      if (bits.length) {
        parts.push('<div class="store-details">' + bits.join('') + '</div>');
      }
      if (!compact && store.notes && !isPickupOnly(store)) {
        parts.push('<p class="notes">' + escapeHtml(store.notes) + '</p>');
      }
      return parts.join('');
    }

    function titleHtml(store) {
      const badge = isPickupOnly(store) ? '<span class="badge">Pickup only</span>' : '';
      return escapeHtml(store.name) + badge;
    }

    function popupHtml(store) {
      return (
        '<div class="popup-card">' +
        '<p class="popup-title">' +
        titleHtml(store) +
        '</p>' +
        detailsHtml(store, false) +
        '</div>'
      );
    }

    function selectStore(id, fromMap) {
      selectedId = id;
      root.querySelectorAll('.store-card').forEach((btn) => {
        btn.classList.toggle('active', btn.getAttribute('data-id') === String(id));
      });
      markersById.forEach((marker, key) => {
        marker.setIcon(pinIcon(String(key) === String(id)));
      });
      const marker = markersById.get(String(id));
      if (marker) {
        if (!fromMap) {
          map.setView(marker.getLatLng(), Math.max(map.getZoom(), 11), { animate: true });
        }
        marker.openPopup();
      }
      const row = root.querySelector('.store-card[data-id="' + CSS.escape(String(id)) + '"]');
      if (row) row.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    }

    function render() {
      const results = filterStores();
      if (els.list) els.list.innerHTML = '';
      markersById = new Map();
      if (markerLayer) markerLayer.clearLayers();

      const withPins = [];
      results.forEach((store) => {
        if (els.list) {
          const li = document.createElement('li');
          const btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'store-card' + (String(store.id) === String(selectedId) ? ' active' : '');
          btn.setAttribute('data-id', store.id);
          btn.innerHTML =
            '<span class="store-icon" aria-hidden="true">🏪</span>' +
            '<span class="store-card-body">' +
            '<h3>' +
            titleHtml(store) +
            '</h3>' +
            detailsHtml(store, false) +
            '</span>';
          btn.addEventListener('click', () => selectStore(store.id, false));
          li.appendChild(btn);
          els.list.appendChild(li);
        }

        if (hasCoords(store) && markerLayer) {
          const marker = L.marker([Number(store.lat), Number(store.lng)], {
            icon: pinIcon(String(store.id) === String(selectedId)),
            title: store.name
          });
          marker.bindPopup(popupHtml(store), { maxWidth: 280 });
          marker.on('click', () => selectStore(store.id, true));
          marker.addTo(markerLayer);
          markersById.set(String(store.id), marker);
          withPins.push(marker);
        }
      });

      const n = results.length;
      if (els.count) els.count.textContent = n === 1 ? '1 shop' : n + ' shops';
      if (els.empty) {
        if (!n) {
          els.empty.classList.remove('hidden');
          els.empty.innerHTML =
            '<strong>No shops popped up for that search.</strong><br>' +
            'Try a nearby city, a ZIP or postal code, or a store name. You can also switch the radius to All. Our retailers live in the US, Canada, Germany, the Netherlands, and South Korea, so a wider net can help.';
        } else {
          els.empty.classList.add('hidden');
          els.empty.textContent = '';
        }
      }

      if (withPins.length && map) {
        const group = L.featureGroup(withPins);
        if (!origin || selectedRadius() === Infinity) {
          map.fitBounds(group.getBounds().pad(0.12), { maxZoom: 12 });
        } else {
          map.setView([origin.lat, origin.lng], radiusZoom(selectedRadius()));
        }
      }

      const q = els.input ? els.input.value.trim() : '';
      if (origin) {
        setStatus(statusForOrigin(n));
      } else if (q) {
        setStatus(n ? 'Showing shops that match your search.' : '');
      } else {
        setStatus('Showing every Honey Bee retailer we know. Add a location to sort by miles.');
      }

      if (map) {
        window.setTimeout(function () {
          map.invalidateSize();
        }, 200);
      }
    }

    function radiusZoom(miles) {
      if (miles <= 25) return 10;
      if (miles <= 50) return 9;
      if (miles <= 100) return 8;
      if (miles <= 250) return 6;
      return 4;
    }

    function statusForOrigin(n) {
      const where = origin.label ? ' near ' + origin.label : '';
      const radius = selectedRadius();
      if (radius === Infinity) {
        return n + (n === 1 ? ' shop' : ' shops') + ' sorted by distance' + where + '.';
      }
      return n + (n === 1 ? ' shop' : ' shops') + ' within ' + radius + ' miles' + where + '.';
    }

    async function geocode(query) {
      if (!geocodeAvailable) return null;
      const url =
        NOMINATIM_URL +
        '?format=json&limit=1&q=' +
        encodeURIComponent(query);
      try {
        const res = await fetch(url, {
          headers: { Accept: 'application/json' }
        });
        if (!res.ok) return null;
        const data = await res.json();
        if (!Array.isArray(data) || !data.length) return null;
        const hit = data[0];
        const lat = Number(hit.lat);
        const lng = Number(hit.lon);
        if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;
        const label = (hit.display_name || query).split(',').slice(0, 3).join(',');
        return { lat, lng, label };
      } catch (err) {
        geocodeAvailable = false;
        return null;
      }
    }

    async function runSearch(fromSubmit) {
      const q = els.input ? els.input.value.trim() : '';
      if (fromSubmit && q) {
        setStatus('Looking that place up...');
        try {
          const geo = await geocode(q);
          if (geo) {
            const qLower = q.toLowerCase();
            const textHits = stores.filter((s) => storeSearchText(s).includes(qLower));
            const miles = selectedRadius() === Infinity ? 250 : selectedRadius();
            const nearby = stores.some(
              (s) => hasCoords(s) && haversineMiles(geo.lat, geo.lng, Number(s.lat), Number(s.lng)) <= miles
            );
            if (nearby || !textHits.length) {
              origin = geo;
            }
          } else if (!geocodeAvailable && !geocodeBlockedNoted) {
            geocodeBlockedNoted = true;
            setStatus(
              'Place lookup is blocked in this browser. Showing shops that match the text instead. You can still tap Use my location.'
            );
          }
        } catch (err) {
          // Keep going with text search (state names like Oregon still match OR).
        }
      }
      render();
    }

    function initMap() {
      if (!els.mapEl) return;
      map = L.map(els.mapEl, { scrollWheelZoom: true, zoomControl: true }).setView(
        DEFAULT_CENTER,
        DEFAULT_ZOOM
      );
      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        maxZoom: 19,
        attribution: '&copy; OpenStreetMap contributors'
      }).addTo(map);
      markerLayer = L.layerGroup().addTo(map);
      window.addEventListener('resize', function () {
        map.invalidateSize();
      });
    }

    function loadStores() {
      if (!els.dataEl) {
        stores = [];
        return;
      }
      try {
        const parsed = JSON.parse(els.dataEl.textContent);
        stores = Array.isArray(parsed) ? parsed : [];
      } catch (err) {
        stores = [];
      }
    }

    if (els.form) {
      els.form.addEventListener('submit', (event) => {
        event.preventDefault();
        runSearch(true);
      });
    }

    if (els.input) {
      els.input.addEventListener('input', () => {
        window.clearTimeout(geocodeTimer);
        geocodeTimer = window.setTimeout(() => render(), 180);
      });
    }

    root.querySelectorAll('input[name="honeybee-radius"]').forEach((input) => {
      input.addEventListener('change', () => {
        if (!origin && selectedRadius() !== Infinity) {
          setStatus('Add a city, ZIP, or tap Use my location so we can measure miles.');
        }
        render();
      });
    });

    if (els.geoBtn) {
      els.geoBtn.addEventListener('click', () => {
        if (!navigator.geolocation) {
          setStatus('This browser cannot share a location. Type a city or ZIP instead.');
          return;
        }
        setStatus('Asking for your location...');
        navigator.geolocation.getCurrentPosition(
          (pos) => {
            origin = {
              lat: pos.coords.latitude,
              lng: pos.coords.longitude,
              label: 'your location'
            };
            render();
          },
          () => {
            setStatus('We could not read your location. Type a city or ZIP in the search box instead.');
          },
          { enableHighAccuracy: false, timeout: 10000, maximumAge: 60000 }
        );
      });
    }

    loadStores();
    initMap();
    if (!stores.length) {
      setStatus('We could not load the shop list just now. Refresh and try again.');
      return;
    }
    render();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
